import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const isTokenExpired = (decoded) => {
    if (!decoded.exp) return true;
    const now = Date.now() / 1000;
    return decoded.exp < now;
  };

  const redirectToLogin = () => {
    window.location.href = "/";
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      try {
        const decoded = jwtDecode(storedToken);

        if (isTokenExpired(decoded)) {
          //console.warn("Token expirado");
          logout();
          redirectToLogin();
        } else {
          setToken(storedToken);
          setUser({ id: decoded.sub, rol: decoded.rol });
          //console.log("Usuario autenticado:", decoded);
        }
      } catch (e) {
        //console.error("Token inválido", e);
        logout();
        redirectToLogin();
      }
    }
    setLoading(false);
  }, []);

  const login = (newToken) => {
    try {
      const decoded = jwtDecode(newToken);

      if (isTokenExpired(decoded)) {
        console.error("Token ya expirado");
        return false;
      }

      localStorage.setItem("token", newToken);
      setToken(newToken);
      setUser({ id: decoded.sub, rol: decoded.rol });
      return true;
    } catch (e) {
      //console.error("Token inválido en login", e);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ token, user, setUser, loading, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
